import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { TaskService } from 'src/app/services/task.service';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/services/user.service';
import { DownloadService } from 'src/app/services/download.service';
import { Subscription, take } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ThemeService } from 'src/app/services/theme.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { PosthogService } from 'src/app/services/posthog.service';
import { USER_CAN_DEPOSIT } from 'src/app/services/constants';
import { SharedDataService } from 'src/app/components/shared/shared-data-service';
import { Announcement } from 'src/app/components/shared/models/layout-model';
import { MatMenuTrigger } from '@angular/material/menu';
import { ApiService } from 'src/app/services/api.service';
import { ANOUNCEMENTS_OPTIONS } from 'src/app/services/constants';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent implements OnInit {
  private inactivityTimeout: any;
  private footerRefreshTimeout: any;
  private readonly INACTIVITY_PERIOD = 3600000 //1hr
  private readonly FOOTER_REFRESH_PERIOD = 3600000 //1hr
  isDownloading: boolean = false;
  private sessionLoggedOut = false;
  @ViewChild(MatMenuTrigger) announcementMenuTrigger!: MatMenuTrigger;

  title = '';
  currentUser: any;

  userid: any;
  show: boolean = true;
  userDetails: any;
  photo: string;
  progress: any = 0;
  progressSubscription: Subscription;
  freeze: boolean = false;
  darkMode: boolean = false;
  isDarkMode: boolean;
  darkTheme: boolean;
  subscribe: boolean;
  isInIframe: boolean;
  feedback: string;
  demoView: boolean = false;
  user: any;
  pointUser: boolean = true;
  USER_CAN_DEPOSIT = USER_CAN_DEPOSIT;
  announcements: Announcement[] = [];
  ANOUNCEMENTS_OPTIONS = ANOUNCEMENTS_OPTIONS;
  loadingAnnouncements : boolean = false;
  unreadCount:number = 0;
  selectedIndex : number = 0;
  isChatOpen = false;
  isBlinking = true;

  constructor(private router: Router, private authService: AuthService, private taskService: TaskService, private userService: UserService, private downloadService: DownloadService,
    private localStorageService: DataService,private posthogService: PosthogService,
    private themeService: ThemeService,
    private sharedDataService: SharedDataService,
    private apiService: ApiService,
    private spinnerService: NgxSpinnerService, 
    ) {
    const darkMode = localStorage.getItem('darkMode');
    if (darkMode === 'true') {
      this.themeService.setDarkMode(true);
      this.localStorageService.updateTheme(true);
    }
    else {
      this.localStorageService.updateTheme(false);
      this.themeService.setDarkMode(false);
    } 

    this.resetInactivityTimer();
    this.resetFooterRefreshTimer();
    this.setupUnloadListener();
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (event?.url.includes('/task')) {
          this.title = 'Dashboard'
        }
        else if (event?.url === '/deposit') {
          this.title = 'Deposit'
          this.show = true;
        }
        else if (event?.url.includes('/cart')) {
          this.title = 'Cart'
          this.show = true;
        }
        else if (event?.url.includes('/collections')) {
          this.title = 'Collections'
          this.show = true;
        }
        else if (event?.url.includes('/orders')) {
          this.title = 'Orders'
          this.show = true;
        }
        else if (event?.url.includes('/deposits')) {
          this.title = 'Deposits'
          this.show = true;
        }
        else if (event?.url.includes('/budget')) {
          this.title = 'Budgets'
          this.show = true;
        }
        else if (event?.url.includes('/quotes')) {
          this.title = 'Quotes'
          this.show = true;
        }
        else if (event?.url.includes('/users/edit')) {
          this.title = 'Edit User'
          this.show = true;
        }
        else if (event?.url.includes('/users/add')) {
          this.title = 'Add New User'
          this.show = true;
        }
        else if (event?.url.includes('/users')) {
          this.title = 'User Management'
          this.show = true;
        }
        else if (event?.url.includes('/sub-accounts/edit')) {
          this.title = 'Edit Sub Account'
          this.show = true;
        }
        else if (event?.url.includes('/sub-accounts/add')) {
          this.title = 'Add Sub Account'
          this.show = true;
        }
        else if (event?.url.includes('/sub-accounts')) {
          this.title = 'Sub Accounts Management'
          this.show = true;
        }
        else if (event?.url.includes('/newbudget')) {
          this.title = 'New Budget'
          this.show = true;
        }
        else if (event?.url.includes('/payment')) {
          this.title = 'Payment'
          this.show = true;
        }
        else if (event?.url.includes('/success')) {
          this.title = 'Payment'
          this.show = true;
        }
        else if (event?.url.includes('/profile')) {
          this.title = 'Profile'
          this.show = true;
        }
        else if (event?.url.includes('/newtask')) {
          this.title = 'New Task'
          this.show = true;
        }
        else if (event?.url.includes('/retask')) {
          this.title = 'Re-Task'
          this.show = true;
        }
        else if (event?.url.includes('/requestdemo')) {
          this.title = 'Request A Demo'
          this.show = false;
        }
        else if (event?.url.includes('/howitworks')) {
          this.title = 'How It Works' 
          this.show = false;
        }
        else if (event?.url.includes('/support')) {
          this.title = 'Contact Us'
          this.show = false;
        }
        else if (event?.url.includes('/privacypolicy')) {
          this.title = 'Eartheye Privacy Policy'
          this.show = false;
        }
        else if (event?.url.includes('/acceptableusepolicy')) {
          this.title = 'Eartheye Acceptable Use Policy'
          this.show = false;
        }
        else if (event?.url.includes('/disclaimer')) {
          this.title = 'Disclaimer'
          this.show = false;
        }
        else if (event?.url.includes('/allocation')) {
          this.title = 'Fund Allocation'
          this.show = true;
        }
        else if (event?.url.includes('/whats-new')) {
          this.title = 'Product Updates'
          this.show = false;
        }
        else if (event?.url.includes('/preview')) {
          this.title = 'Preview'
          this.show = false;
        }
        else if (event?.url.includes('/termsofuse')) {
          this.title = 'Terms Of Use' 
          this.show = false;
        }

      }
      if (event instanceof NavigationStart) {
        this.closeAnnouncements();
      }

    });

    this.progressSubscription = this.downloadService.getProgressObservable().subscribe(
      progress => {
        this.progress = progress?.progress;
        if (progress?.downloadClick && progress.progress < 100) {
          this.freeze = true;
        } else {
          this.freeze = false;
        }
      }
    );
  }
  resetInactivityTimer(): void {
    clearTimeout(this.inactivityTimeout);
    if (!this.isDownloading) {
      this.inactivityTimeout = setTimeout(() => {
        this.authService.redirectURL = "";
        this.logoutAndReset();
      }, this.INACTIVITY_PERIOD);
    }
  }

  resetFooterRefreshTimer(): void {
    clearTimeout(this.footerRefreshTimeout);
    if (!this.isDownloading) {
      this.footerRefreshTimeout = setTimeout(() => {
        if (!this.sessionLoggedOut) {
          this.logoutAndReset(); // Unified session timeout logic
        }
        this.authService.redirectURL = "";
      this.authService.logout();
        this.router.navigate(['login']);
      }, this.FOOTER_REFRESH_PERIOD);
    }
  }

  @HostListener('document:mousemove')
  @HostListener('document:keypress')
  @HostListener('document:scroll')
  @HostListener('document:click')
  @HostListener('document:wheel')
  @HostListener('document:touchstart')
  resetTimer(): void {
    clearTimeout(this.inactivityTimeout);
    clearTimeout(this.footerRefreshTimeout);
    this.resetInactivityTimer();
    this.resetFooterRefreshTimer();
  }
  setupUnloadListener(): void {
    window.addEventListener('unload', () => {
      clearTimeout(this.inactivityTimeout);
      clearTimeout(this.footerRefreshTimeout);
    });
  }

  ngOnInit(): void {
    setInterval(() => {
        this.isBlinking = true;
        setTimeout(() => {
          this.isBlinking = false;
        }, 600); // duration of blinkOnce animation
    }, 3000); // blink every 3 seconds
    window.addEventListener('storage', (event) => {
      if (event.key === 'logout-event') {
        //User logged out from another tab
        this.authService.logout();
        this.router.navigate(['login']);
      }
    });
    this.isInIframe = this.themeService.isInIframe();
    
    this.localStorageService.subscribedUser.subscribe((newValue) => {
      this.subscribe = newValue;
    });

    this.localStorageService.darkTheme.subscribe((newValue) => {      
      this.darkTheme = newValue;
      this.themeService.setDarkMode(this.darkTheme);
      this.feedback = this.darkTheme ? '../../../assets/images/icon2.svg' : '../../../assets/images/icon1.svg';

    });

    if(environment.demoView === 'true') {
      this.demoView = true;
    }
    else {
      this.demoView = false;
    }

    // Subscribe to the downloading status from the DownloadService
    this.downloadService.isDownloading$.subscribe((isDownloading) => {
      this.isDownloading = isDownloading;
      this.resetInactivityTimer();
    });

    this.getJwtData();
    
    this.authService.getCurrentUser();
    const castUser = this.authService.castCurrentUser.pipe(take(1)).subscribe(async (res: any) => {
      this.currentUser = await res;
      if (this.currentUser?.id) {
        this.userService.personalInfo(this.currentUser?.id).subscribe(async (res: any) => {
          this.userDetails = await res;
           this.sharedDataService.setData(this.userDetails);
          this.darkTheme = this.userDetails?.darkMode;
          this.isDarkMode = this.userDetails?.darkMode;
          this.themeService.setDarkMode(this.isDarkMode);
          this.localStorageService.updateTheme(this.isDarkMode);
          localStorage.setItem('darkMode', JSON.stringify(this.isDarkMode));

          if (this.userDetails.photo !== undefined && !this.userDetails.photo.includes('eeusersapi'))
            this.photo = environment.usersServer + "/data/" + this.userDetails.photo;
        });
        let params:any = {
          period : this.ANOUNCEMENTS_OPTIONS[this.selectedIndex].value,
          markAsRead: false
        }
        this.userid = this.currentUser.id;
        this.loadAnnouncements(params);
        if (this.currentUser.userType === 'admin')
          this.userid = this.userid + 'admin';
      } else if (this.show) {
        sessionStorage.removeItem('jwttoken');
        localStorage.removeItem('key');
        this.authService.logout();
        this.router.navigate(['login']);
      }
      castUser.unsubscribe();
    });

    this.localStorageService.refreshUserDetails$.subscribe((userId: number) => {
      this.updateUserDetails(userId);
    });
  }

  getJwtData() {
    let tokenStr: any = sessionStorage.getItem('jwttoken')!;
    if (tokenStr) {
      if (tokenStr.includes('Msg')) return tokenStr;
      const decodedToken: any = new JwtHelperService().decodeToken(tokenStr);
      if (decodedToken) {
        if (decodedToken?.id) {
          this.userService.personalInfo(decodedToken?.id).subscribe((result: any) => {
            this.user = result;
            this.pointUser = this.user.pointsEligible;
          });
        }
      }
    }
  }

  logoutAndReset(): void {
    if (this.sessionLoggedOut) return;
    this.sessionLoggedOut = true;
    const username = localStorage.getItem('loggedUser') || 'Unknown';
    this.posthogService.capture('Session-Timeout', {
      method: 'standard',
      distinct_id: this.currentUser?.id || 'unknown_user',
      message: `${username} was logged out due to session timeout.`,
      email:username,
      reason: 'inactivity',
      duration: this.INACTIVITY_PERIOD,
      timestamp: new Date().toISOString()
    });
    this.authService.logoutAndReset();
    localStorage.setItem('logout-event', Date.now().toString());
  }
  manualLogout(): void {
    // Call the logout() method without triggering automatic logout and refresh.
    this.authService.logout();
    this.router.navigateByUrl('/logout', { skipLocationChange: true });
  }

   ngOnDestroy(): void {
    clearTimeout(this.inactivityTimeout);
    clearTimeout(this.footerRefreshTimeout);
  }

  logout(): void {
    this.authService.logout();
    this.authService.redirectURL="";
    this.router.navigate(['login']);
    this.localStorageService.updateTheme(false);
    this.themeService.setDarkMode(false);
    localStorage.removeItem('darkMode');
    localStorage.setItem('logout-event', Date.now().toString());
  }

  toggleTheme() {
    this.isDarkMode = !this.isDarkMode;
    this.themeService.setDarkMode(this.isDarkMode);
    localStorage.setItem('darkMode', JSON.stringify(this.isDarkMode));
    this.localStorageService.updateTheme(this.isDarkMode);
    this.userService.updateTheme(this.currentUser?.id,this.isDarkMode).subscribe(async (res: any) => {
    });
  }

  updateUserDetails (userId) {
    this.userService.personalInfo(userId).subscribe(async (res: any) => {
      this.userDetails = await res;
    });
  }
 hasFeature(key: string): boolean {
  return this.userDetails?.planDetails?.features?.some(feature => feature.key === key);
}
  onTabChange(index: number) {
    const selectedValue = this.ANOUNCEMENTS_OPTIONS[index].value;
    this.announcements = [];
    let params:any = {
        period : selectedValue,
        markAsRead: true
      }
    this.loadAnnouncements(params);
  }

  get hasUnread(): boolean {
  return this.announcements.some(a => !a.read);
 }

loadAnnouncements(params: any) {
  this.loadingAnnouncements = true;
  this.spinnerService.show();
  this.apiService
    .getAnnouncementHistory(this.userid, params)
    .subscribe({
      next: (res:any) => {
        this.announcements = (res?.data?.announcements || res || []).map((a: any) => ({
          id: a._id,
          title: a.title,
          description: a.content,
          date: new Date(a.start_date),
          read: a.isRead
        }));
        
        let unreadCount = 0;
        
        if(params.markAsRead == true){
          unreadCount = this.announcements.filter((s:any)=> s.read == false).length;
          this.unreadCount = res?.data?.unreadCount - unreadCount;
        }else{
          this.unreadCount = res?.data?.unreadCount;
        }
        this.loadingAnnouncements = false;
        this.spinnerService.hide();

      },
      error: (err) => {
        this.announcements = [];
        this.loadingAnnouncements = false;
        this.spinnerService.hide();
      }
    });
  }
  toggleChat() {
    if(this.announcementMenuTrigger?.menuOpen && !this.isChatOpen) this.closeAnnouncements();
    this.isChatOpen = !this.isChatOpen;

    if (!this.isChatOpen) {
      this.isBlinking = false;
      setTimeout(() => this.isBlinking = true, 50);
    } else {
      this.isBlinking = false;
    }
  }

  closeAnnouncements() {
    this.announcements = [];
    this.announcementMenuTrigger.closeMenu();
  }

  onAnnouncementsOpened(){
    this.selectedIndex = 0;
      let params:any = {
        period : this.ANOUNCEMENTS_OPTIONS[this.selectedIndex].value,
        markAsRead: true
      }
      this.loadAnnouncements(params);
  }
}
